var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Login/RS Facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97998 2.77002C4.18506 2.77002 2.72998 4.22509 2.72998 6.02002V18.02C2.72998 19.8149 4.18506 21.27 5.97998 21.27H17.98C19.7749 21.27 21.23 19.8149 21.23 18.02V6.02002C21.23 4.22509 19.7749 2.77002 17.98 2.77002H5.97998ZM1.22998 6.02002C1.22998 3.39667 3.35663 1.27002 5.97998 1.27002H17.98C20.6033 1.27002 22.73 3.39667 22.73 6.02002V18.02C22.73 20.6434 20.6033 22.77 17.98 22.77H5.97998C3.35663 22.77 1.22998 20.6434 1.22998 18.02V6.02002Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.85 7.46002C14.6042 7.46002 13.6 8.46424 13.6 9.71002V22.02C13.6 22.4342 13.2642 22.77 12.85 22.77C12.4358 22.77 12.1 22.4342 12.1 22.02V9.71002C12.1 7.63581 13.7758 5.96002 15.85 5.96002H17.77C18.1842 5.96002 18.52 6.29581 18.52 6.71002C18.52 7.12424 18.1842 7.46002 17.77 7.46002H15.85Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.02 12.88C10.02 12.4658 10.3558 12.13 10.77 12.13H17.78C18.1942 12.13 18.53 12.4658 18.53 12.88C18.53 13.2942 18.1942 13.63 17.78 13.63H10.77C10.3558 13.63 10.02 13.2942 10.02 12.88Z",
    fill: "#FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsFacebook);
export default __webpack_public_path__ + "static/media/RSFacebook.dfdd2b1d220ff5dd54447a19047ecfd5.svg";
export { ForwardRef as ReactComponent };